
<template>
  <div :class="[subject==1 || subject==2 || subject==3 ? 'course'+subject :'course',isNoviceClass?'novice_class':'', 'compose', 'pdf-page']">
    <div class="iframe-box" v-if="isShowiframe">
      <img class="close cursor" @click="closePdf" alt="关闭" title="关闭" src="../../../assets/img/course/close.png">
      <iframe class="pdf-iframe" :src="pdfUrl" frameborder="0"></iframe>
    </div>

    <div class="header">
      <span @click="go_class" class="cursor"></span>
      <h2>{{title}}</h2>
      <div class="down-btn cursor" @click="downPdfZip" v-if="pdfList.zipUrl && pdfList.zipUrl != ''">下载所有文件</div>
    </div>
    <div class="lottie"></div>
    <div class="pdf-box">
      <template v-if="showDir">
        <div
          class="pdf cursor"
          v-for="(item,index) in pdfListDir"
          :key="index"
          @click="showPdf(index)"
        >
          <img src="../../../assets/img/class/folder-icon.png"/>
          <p>{{item.dirName}}</p>
        </div>
      </template>
      <template v-else>
        <div
          class="pdf cursor"
          v-for="(item,index) in pdfList.pdfList"
          :key="index"
          @click="openPdf(item.pdfUrl)"
        >
          <img src="../../../assets/img/class/pdf.png"/>
          <p>{{item.pdfName}}</p>
        </div>
      </template>
      <p v-if="(showDir && pdfListDir.length === 0) || (!showDir && pdfList.pdfList.length === 0)">学习资料正在准备中...</p>
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations} from 'vuex';
import lottie from "lottie-web-limi";
import common from "common";
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: 'course_pdf_list',
  data() {
    return {
      anim: '',
      subType: '',
      zipUrl: '',
      baseUrl: '',
      pdfList: [],
      pdfUrl: '',
      isShowiframe: false,
      isShowiframe1: false,
      pdfListDir: [],
      showDir: true,
      title: ''
    };
  },
  components: {

  },
  computed: {
    ...mapState(['class_name','subject',"isNoviceClass", "composeLessInfo"])
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setLottieSize)
  },
  mounted() {
    this.title = `${this.class_name}_学习资料`
    this.setLottieSize()
    window.addEventListener('resize', this.setLottieSize)
    this.handleAnimation();
    const res = common.getSession("lesson_list_data");
    const {zipUrl, baseUrl, pdfListDir} = res.learningMaterialsList;
    this.pdfListDir = pdfListDir;
  },
  methods: {
    ...mapMutations([

    ]),
    showPdf(index) {
      this.showDir = false;
      const pdfArr = this.pdfListDir[index];
      this.pdfList = this.pdfListDir[index].pdfList;
      this.baseUrl = pdfArr.pdfList.baseUrl;
      this.zipUrl = pdfArr.pdfList.baseUrl + pdfArr.pdfList.zipUrl;
      this.title = this.pdfListDir[index].dirName;
    },
    go_class(){
      if(!this.showDir) {
        this.showDir = true;
        this.pdfList = [];
        this.baseUrl = '';
        this.zipUrl = '';
        this.title = `${this.class_name}_学习资料`;
        return;
      }
      //返回课时列表
      this.$store.commit('saveShowCoursePdf', false);
    },
    downPdfZip() {
      var form = document.createElement('form');
      form.action = this.zipUrl;
      document.getElementsByClassName('pdf-page')[0].appendChild(form);
      form.submit();
    },
    openPdf(pdfUrl) {
      const url = this.baseUrl + pdfUrl;
      if (LIMI_ENV === "electron") {
        let kejian_url = common.API["800001"] || "https://live-qs-player.limiketang.com/index.html";
        let idx = kejian_url.lastIndexOf('/');
        this.pdfUrl = kejian_url.substring(0, idx + 1) + "pdfjs/web/viewer.html?file=" + encodeURIComponent(url);
        this.isShowiframe = true;

        //下载逻辑
        // var oReq = new XMLHttpRequest();
        // oReq.open("GET", url, true);
        // oReq.responseType = "blob";
        // oReq.onload = function() {
        //   var file = new Blob([oReq.response], {
        //     type: "application/pdf"
        //   });
        //   var link = document.createElement("a");
        //   link.download = '1111.pdf'
        //   link.href = URL.createObjectURL(file);
        //   link.click();
        //   URL.revokeObjectURL(file);
        // };
        // oReq.send();

      } else {
        window.open(url);
      }

    },
    closePdf() {
      this.isShowiframe = false;
    },
    handleAnimation() {
      // console.log('subject', this.subject)
      const subTypes = {
        1: 'shuxue',
        2: 'yuwen',
        3: 'yingyu',
        4: 'xinshou',
        5: 'beiyong'
      }
      let subType = this.isNoviceClass ? 4 : (this.subject != 1 && this.subject != 2 && this.subject != 3) ? 5 : this.subject
      this.subType = subTypes[subType]
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: `/static/lottie/${this.subType}/a.json`
      });
    },
    playAnim() {
      this.anim.play();
      // this.anim.goToAndStop(200)
    },
    setLottieBoxSize() {
      let clientWidth = document.body.clientWidth
      let clientHeight = document.body.clientHeight
      let scaleWindow = clientWidth / clientHeight
      let scaleLottie = 	1280 / 720
      let lottieDom = document.querySelector(".lottie")
      let scale
      let offset
      if (scaleWindow > scaleLottie) {
        scale = clientWidth / 1280
        lottieDom.style.height = 100 * scale + '%'
        lottieDom.style.width = '100%'
        offset = (100 * scale - 100) / 2
        lottieDom.style.top = `-${offset}%`
        lottieDom.style.left = `0`
        if (clientHeight < 720) {

          let scaleY = 720 / clientHeight
          console.log(scaleY)
          lottieDom.style.width = 100 * scale + '%'
          lottieDom.style.height = 720 * scaleY + 'px'
          lottieDom.style.left = `-${(100 * scale - 100) / 2}%`
        }
      } else if (scaleWindow < scaleLottie) {
        scale = 720 / clientHeight
        lottieDom.style.width = 100 / scale + '%'
        lottieDom.style.height = '100%'
        offset = (100 / scale - 100) / 2
        // console.log((100 / scale - 100),lottieDom.style.width)
        lottieDom.style.left = `-${offset}%`
        lottieDom.style.top = `0`
      }
    },
    setLottieSize() {
      let clientWidth = document.body.clientWidth
      let clientHeight = document.body.clientHeight
      let lottieDom = document.querySelector(".lottie")
      if(!lottieDom)return;
      if (clientHeight >= 720 && clientWidth >= 1280) {
        if (clientWidth / clientHeight > 1280 / 720) {
          lottieDom.style.width = '100%';
          lottieDom.style.height = 720 / 1280 * clientWidth + 'px';
        } else {
          lottieDom.style.height = '100%';
          lottieDom.style.width = (1280 / 720) * clientHeight + 'px'
        }
      } else if (clientHeight > 720 && clientWidth < 1280) {
        lottieDom.style.height = '100%';
        lottieDom.style.width = (1280 / 720) * clientHeight + 'px'
      } else if (clientHeight < 720 && clientWidth < 1280){
        lottieDom.style.height = '720px';
        lottieDom.style.width = '1280px';
      } else if (clientHeight < 720 && clientWidth > 1280) {
        lottieDom.style.width = '100%';
        lottieDom.style.height = 720 / 1280 * clientWidth + 'px';
      }
    }
  }
}
</script>
<style scoped lang="less" rel="stylesheet/less">
.course,.course1,.course2,.course3{
  width: 100%;
  height: 100%;
  background: url(/static/img/course/bg0.png) no-repeat;
  position: relative;
  overflow: hidden;
  background-size:cover;
}
.lottie{
  width: 100%;
  height: 720px;
  position: absolute;
  z-index: 0;
}
.course1{
  background: url(/static/img/course/bg1.png) no-repeat;
  background-size:cover;
}
.course2{
  background: url(/static/img/course/bg2.png) no-repeat;
  background-size:cover;
}
.course3{
  background: url(/static/img/course/bg3.png) no-repeat;
  background-size:cover;
}
.novice_class{
  background: url(/static/img/course/novice_bg.png) no-repeat;
  background-size:cover;
}
.header{
  position: absolute;
  z-index: 99;
  width: 100%;
  height:83px;
  padding-top: 20px;
  span{
    position: absolute;
    width: 56px;
    height: 56px;
    background:url('../../../assets/img/common/arrow_left1.png') no-repeat center center;
    background-size:100% 100% ;
    border-radius: 50%;
    left: 30px;
    top: 20px;
    &:hover{
      background:rgba(0,0,0,0.08) url('../../../assets/img/common/arrow_left1.png') no-repeat center center;
      background-size:100% 100% ;
    }
  }
  h2{
    font-family: PingFang_Medium;
    font-weight: normal;
    font-size: 30px;
    padding-top:10px;
    color:#fff;
  }
  .down-btn {
    position: absolute;
    top: 20px;
    right: 100px;
    width: 150px;
    height: 50px;
    border-radius: 25px;
    line-height: 50px;
    font-size: 18px;
    color: #ffffff;
    background-color: #0a556b;
    text-align: center;
  }
  i{
    position: absolute;
    top: 10px;
    right: 30px;
    width: auto;
    height: 50px;
    font-family: Roboto_Regular;
    background:rgba(0,0,0,0.15) url(../../../assets/img/common/coin.png) no-repeat left center;
    border-radius: 25px;
    background-size:50px 50px;
    font-size: 24px;
    line-height: 50px;
    color: #007A9C;
    text-align: center;
    padding: 0 22px 0 64px;
  }
}
.pdf-box {
  position: relative;
  z-index: 1;
  //width: 80%;
  width: 1024px;
  background: #fff;
  border-radius: 20px;
  min-height: 670px;
  max-height: 80%;
  height: 100%;
  overflow-y: scroll;
  margin: 103px auto 0;
  padding: 50px 25px 0px 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
  //align-content: space-between;
  .pdf {
    width: 130px;
    height: 170px;
    margin: 0 15px 20px;
    img {
      display: block;
      width: 90px;
      height: 90px;
      margin: 0 auto;
    }
    p {
      width: 100%;
      margin-top: 20px;
      text-align: center;
      color: #0b7fc7;
      font-size: 16px;
      font-family: HYZhengYuan;
      font-weight: 400;
      line-height: 24px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      display: -moz-box;
      -moz-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      /*! autoprefixer: on */
    }
  }
  &>p {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    font-size: 20px;
  }
}
.pdf-box::-webkit-scrollbar {display:none}
.iframe-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
}
.iframe-box .close {
  width: 28px;
  height: 28px;
  padding: 7px;
  position: absolute;
  top: 2px;
  right: 10px;
  z-index: 1;
}
.iframe-box .close:hover{
  background-color: #666667;
}
.iframe-box .pdf-iframe {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/coursePdf/course_pdf_list.vue